import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/prints",
      name: "prints",
      meta: { requiresAuth: true, title: "routes.prints" },
      component: () => import("./main.vue")
    }
  ]
};
